// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footer-logo":"Footer_footer-logo__X69RK","footer-nav":"Footer_footer-nav__XvRDp","socials":"Footer_socials__BkTPo"};